import React from "react";

export const CARD = "CARD";

// Bank card choice of the payment pages, shown under the Mobile Money ones
function CardPaymentMethod({ selected, onSelect }) {
  return (
    <button
      type="button"
      role="radio"
      aria-checked={selected}
      className={`cart-pay-method is-card ${selected ? "is-selected" : ""}`}
      onClick={onSelect}
    >
      <span className="cart-pay-cards" aria-hidden="true">
        <img src="/images/payment/visa.png" alt="" />
        <img src="/images/payment/mastercard.jpg" alt="" />
      </span>
      <span>Carte bancaire</span>
    </button>
  );
}

export default CardPaymentMethod;
